export const MOBILE_IMAGE_SIZE = '318px';
export const DESKTOP_IMAGE_SIZE = '456px';
